import React from 'react';
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import {baseUrl_back} from "../../api/BaseUrl";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import PhoneIcon from "@mui/icons-material/Phone";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import HomeIcon from '@mui/icons-material/Home';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';


import "../../index.css"
import {
    Icon_Call_color,
    Icon_Heart_color,
    Icon_Instagram_color,
    Icon_Shopping_color,
    Icon_Telegram_color,
    Icon_VK_color,
    Icon_WhatsApp_color
} from "../../api/Components/Icons/Icons";
import {Modal} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const CompactView = (props) => {
    const pages = ['Главная','Каталог', 'Покупателям', 'Контакты', 'ПУБЛИЧНАЯ ОФЕРТА'];
    const settings =  ['Главная','Каталог', 'Покупателям', 'Контакты', 'ПУБЛИЧНАЯ ОФЕРТА'];
    const icons=[<HomeIcon className={"myfont16m"} />,<LoyaltyIcon className={"myfont16m"} />,<HelpCenterIcon className={"myfont16m"} />,<PermContactCalendarIcon className={"myfont16m"} />]
    const icons2=[<PhoneIcon className={"myfont16m"} />,Icon_Telegram_color,Icon_VK_color,<PermContactCalendarIcon className={"myfont16m"} />]

    const [state, setState] = React.useState({left: false,});
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    //
    let navigate = useNavigate();
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
       // console.log("ddd")
    };
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const tofavor=()=>{
        navigate('/favorites')
    }
    const tocart=()=>{
        navigate('/cart')
    }

    const vkklico=()=>{
        window.open('https://vk.com/go_bananas_ru')
    }
    // const instalico=()=>{
    //     window.open('https://www.instagram.com/go_bananas_ru/')
    // }
    const telephone=()=>{
        window.open('tel://+79163865050')
    }
    const telegram=()=>{
        window.open('http://t.me/Go_bananas_ru')
    }
    const whatsupp=()=>{
        window.open('https://wa.me/79032092209')
    }


    const handleCloseNavMenu = (event) => {
        // console.log(event.target.innerHTML)
        // console.log(event)
        if (event.target.innerHTML=="Главная") {
            navigate('/');
        }
        if (event.target.innerHTML=="Каталог") {
            navigate('/newcatalog');
        }
        if (event.target.innerHTML=="Покупателям") {
            navigate('/info');
        }
        if (event.target.innerHTML=="Контакты") {
            navigate('/contacts');
        }
        if (event.target.innerHTML=="ПУБЛИЧНАЯ ОФЕРТА") {
            navigate('/oferta');
        }
        if (event.target.innerHTML=="Позвонить") {
            window.open('tel://+79163865050')
        }


        if (event.target.innerHTML=="Telegram") {
            window.open('https://t.me/gobananaswear')
        }
        if (event.target.innerHTML=="ВКонтакте") {
            window.open('https://vk.com/go_bananas_ru')
        }

    };
    // #############################################
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <Box className={"myfont16m"}
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}

        >
            <List>

                {settings.map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton onClick={handleCloseNavMenu} >
                            <ListItemIcon>
                                {icons[index]}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                {['Позвонить', 'Telegram', 'ВКонтакте'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton  onClick={handleCloseNavMenu} >
                            <ListItemIcon>
                                {icons2[index]}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
    return (
        <>
            <Box  sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer('left', true)}
                    edge="start"
                    sx={{
                        marginRight: 5,
                        // ...(open && { display: 'none' }),
                    }}
                >
                    <MenuIcon />
                </IconButton>
            </Box>
            <Typography
                variant="h1"
                noWrap
                component="a"
                href=""
                sx={{
                    mr: 2,
                    display: { xs: 'flex', md: 'none' },
                    flexGrow: 1,
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    marginRight:'0px',
                    align: 'center',
                    justifyContent: 'flex-start',
                    textDecoration: 'none',
                }}
            >
                <img src={baseUrl_back+"/Static/Images/Logos/logo_color.svg"} alt="GO BANANAS" />
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                <img src={baseUrl_back+"/Static/Images/Logos/logo_color.svg"} alt="GO BANANAS" />
                <a>®</a>


                {pages.map((page) => (
                    <Button
                        key={page}
                        variant="text"
                        onClick={handleCloseNavMenu}
                        sx={{ my: 2, color: 'lightGray', display: 'block' }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Negara',
                                letterSpacing: '.1rem',
                                fontWeight: 600,
                                fontSize: 14
                            }}

                            noWrap

                        >
                            {page}
                        </Typography>

                    </Button>

                ))}

            </Box>
            <Box className={"myfont16m"} sx={{ flexGrow: 0 }}>

                {(props.isMobile==false)?(<>

                    <Tooltip title="ВКонтакте">
                        <IconButton aria-label="vkontakte" onClick={vkklico}>
                            {Icon_VK_color}
                        </IconButton>
                    </Tooltip>
                    {/*<Tooltip title="Инстаграмм">*/}
                    {/*    <IconButton aria-label="vkontakte" onClick={instalico}>*/}
                    {/*        {Icon_Instagram_color}*/}
                    {/*    </IconButton>*/}
                    {/*</Tooltip>*/}
                    <Tooltip title="Телефон">
                        <IconButton aria-label="telephone" onClick={telephone}>
                            {Icon_Call_color}
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Telegram">
                        <IconButton aria-label="Телеграм" onClick={telegram}>
                            {Icon_Telegram_color}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="WhatsApp">
                        <IconButton size={"medium"} aria-label="Телеграм" onClick={whatsupp}>
                            {Icon_WhatsApp_color}
                        </IconButton>
                    </Tooltip>
                </>):(<></>)}
                <Tooltip title="Избранное">
                    <IconButton aria-label="favor" onClick={tofavor}>
                        <Badge badgeContent={props.lenfavorites}     color="info">
                            {Icon_Heart_color}
                        </Badge>
                    </IconButton>
                </Tooltip>

                <Tooltip title="Корзина">
                    <IconButton aria-label="cart" onClick={tocart}>
                        <Badge badgeContent={props.lenCart}    color="info">
                            {Icon_Shopping_color}
                        </Badge>
                    </IconButton>

                </Tooltip>

                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    {settings.map((setting) => (
                        <MenuItem key={setting} onClick={handleCloseUserMenu}>
                            <Typography textAlign="center">{setting}</Typography>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
            <React.Fragment key='left'>
                <SwipeableDrawer
                    anchor='left'
                    open={state['left']}
                    onClose={toggleDrawer('left', false)}
                    onOpen={toggleDrawer('left', true)}
                >
                    {list('left')}
                </SwipeableDrawer>
            </React.Fragment>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
               <a>asdas</a>
            </Modal>
        </>
    );
};

export default CompactView;